module.exports = __webpack_public_path__ + "img/media-pharma.27cfbe62.png";